export const SHIKI_THEMES = {
  light: "vitesse-light",
  dark: "vitesse-dark",
} as const;
